import { useEffect, useRef } from "react";
import QRCode from "qrcode";

/**
 * Compact QR code renderer. Encodes an in-app deep link so a phone camera
 * (or the bakery's USB scanner) lands directly on the matching cleaning task.
 */
export function CleaningQR({ value, size = 96, testId }) {
  const ref = useRef(null);
  useEffect(() => {
    if (!ref.current || !value) return;
    QRCode.toCanvas(ref.current, value, {
      width: size,
      margin: 1,
      color: { dark: "#1c1917", light: "#ffffff" },
    }).catch(() => {});
  }, [value, size]);
  return <canvas ref={ref} width={size} height={size} data-testid={testId} />;
}
